import { PerspectiveCamera, Vector2 } from "three";
import { OrbitControls } from "three/examples/jsm/Addons.js";

import { lisa } from "./Lisa.js";
import { DEVICE, LAYERS } from "./constants.js";
import { globalUniforms } from "./utils/uniforms.js";

const BASE_FOV = 45;
export const MOBILE_FOV = 80;

class MainCamera extends PerspectiveCamera {
    orbitControls;
    constructor() {
        super(BASE_FOV, lisa.viewport.ratio, 0.1, 100);

        lisa.state.register(this);

        this.layers.disableAll();
        this.layers.enable(LAYERS.OUTSCREEN);

        this.position.z = 5;

        this.mouse = new Vector2();
        this._position = this.position.clone();
        this._rotation = this.rotation.clone();

        if (lisa.debug && lisa.searchParams.has("orbit")) {
            this.orbit = true;
            new OrbitControls(this, lisa.$wrapper);
        }
    }

    reset() {
        this.position.set(0, 0, 5);
        this.rotation.set(0, 0, 0);
        this.mouse.set(0, 0);
    }

    onResize({ width, height, ratio }) {
        this.aspect = ratio;
        this.fov =
            width < 1000 ? MOBILE_FOV : BASE_FOV / Math.min(1, ratio * 1.5);
        this.updateProjectionMatrix();
    }

    onTick = ({ et, dt }) => {
        if (this.orbit) return;
        if (DEVICE.MOTION) {
            this.mouse.lerp(globalUniforms.uMotion.value, dt);
        } else {
            this.mouse.lerp(lisa.mouse, dt);
        }

        this.position.copy(this._position);
        this.rotation.copy(this._rotation);

        this.position.x += this.mouse.x * 0.2;
        this.position.y += this.mouse.y * 0.2;

        this.rotation.x -= this.mouse.y * 0.1;
        this.rotation.y += this.mouse.x * 0.1;
    };
}

export { MainCamera };
